import "./styles.css"

export default function Loading({ isLoading }) {
    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }
}
